import Vue from 'vue'

Vue.filter('simplePluralize', function (value, singular, plural) {
  if (value != 1) {
    return plural
  } else {
    return singular
  }
})

Vue.filter('dateNL', value => {
  if (value == null) {
    return '-'
  }
  return moment.utc(value).local().format('D MMM YYYY')
})

Vue.filter('formatDate', (date, format) => {
  if (format) {
    return moment.utc(date).local().format(format)
  }

  return moment.utc(date).local().format('DD-MM-YYYY')
})

Vue.filter('dateTimeNL', value => {
  return moment.utc(value).local().format('DD-MM-YYYY HH:mm')
})

Vue.filter('currencyNL', value => {
  if (typeof value === 'undefined') {
    return ''
  }

  return value.toLocaleString('nl-NL', {
    // style: 'currency',
    // currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  })
})

Vue.filter('numberFormatNL', value => {
  if (typeof value === 'undefined') {
    return ''
  }

  return value.toLocaleString('nl-NL', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  })
})

Vue.filter('strReplace', (value, heaystack, str, replace) => {
  return haystack.replace(str, replace)
})

Vue.filter('nl2br', (value) => {
  return value.replace(/(\r\n|\n\r|\r|\n)/g, '<br>')
})

Vue.filter('truncate', (text, length, clamp) => {
  text = text || ''
  clamp = clamp || '...'
  length = length || 30

  if (text.length <= length) return text

  var tcText = text.slice(0, length - clamp.length)
  var last = tcText.length - 1

  while (last > 0 && tcText[last] !== ' ' && tcText[last] !== clamp[0]) last -= 1

  // Fix for case when text dont have any `space`
  last = last || length - clamp.length

  tcText = tcText.slice(0, last)

  return tcText + clamp
})
